module.exports = __webpack_public_path__ + "img/Parkandride-icon.c7126cbb.svg";